/**
 * Snippet: Page Sign-up Form
 * ------------------------------------------------------------------------------
 * Connects to the Como API
 *
 * @namespace StorePageSingUpSection
 */
if (!customElements.get('store-page-sign-up')) {
  
  class StorePageSingUpSection extends HTMLElement {
    constructor() {
      super();

      // FORM SUBMISSION VARIABLES
      // Get the generic string value from the form data (the location)
      this.location = this.dataset.location ? this.dataset.location : 'Online';
      // Get message container for errors
      this.messageContainer = this.querySelector('.como-form__message');
      //get button to add event listener
      this.button = this.querySelector('.como-form__btn');
      // Get tag from the form data
      this.tag = this.dataset.tag ? this.dataset.tag : null; 
      

      if ( !this.messageContainer || !this.button) return;

      //add event listener
      this.button.addEventListener("click", this.getData.bind(this));


      //DYNAMIC OFFER VARIABLES
      // Get offer candidate boolean from the form data (whether date falls between offer start and end date)
      this.offerCandidate = this.dataset.offerCandidate ? this.dataset.offerCandidate : false;
      // Get offer tag boolean from the form data (whether offer tag exists that's needed to trigger the campaign)
      this.offerTag = (this.dataset.offerTag && this.dataset.offerTag != "") ? this.dataset.offerTag : false;
      //get search params from url (whether the user landed on the page from a paid ad marketing the offer)
      this.searchParams = new URLSearchParams(window.location.search);

      this.displayOffer = false;
      if ( this.offerCandidate == "true" && this.searchParams.get('limited-time-offer') == "true" && this.offerTag != false ){
        this.displayOffer = true;
        this.showOffer(this.offerTag);
      }

    }

    showOffer() {

      // Get offer heading from the form data
      this.offerHeading = this.dataset.offerHeading ? this.dataset.offerHeading : false;
      // Get offer description from the form data
      this.offerDescription = this.dataset.offerDescription ? this.dataset.offerDescription : false;
      // Get reveal selector from the form data
      this.revealSelector = this.dataset.revealSelector ? this.dataset.revealSelector : false;
      // Get heading container
      var headingContainer = this.querySelector(".store-page-sign-up__text__heading");
      // Get description container
      var descriptionContainer = this.querySelector(".store-page-sign-up__text__description");

      //update submission tag
      this.tag = this.offerTag;

      //update heading
      if (this.offerHeading != false ){
        if (headingContainer) {
          headingContainer.innerHTML = this.offerHeading;
        } else {
          var textContainer = this.querySelector(".store-page-sign-up__text");
          var template = this.querySelector(".store-page-sign-up__text template");

          if (textContainer && template) {
            textContainer.prepend(template.content);
          }
        }
      } else {
        headingContainer.remove();
      }

      //update description
      if (this.offerDescription != false ){
        if (descriptionContainer) {
          descriptionContainer.innerHTML = this.offerDescription;
        }
      } else {
        descriptionContainer.innerHTML = "";
      }

      //reveal elements initially hidden in other sections
      if (this.revealSelector != false ){
        let template = document.querySelector(`${this.revealSelector} template`);
        if (template) {
          template.parentNode.insertBefore(template.content, template);
          template.remove();
        }
      }
    }

    getData(event) {
        // Prevent the default form submission behavior
        event.preventDefault();
        this.button.disabled = true;
        console.log("Register button disabled");

        // Get the first name value from the form input
        this.fName = this.querySelector('.como-form__input__f-name').value;

        // Get the last name value from the form input
        this.lName = this.querySelector('.como-form__input__l-name').value;
        
        // Get the email value from the form input
        this.email = this.querySelector('.como-form__input__email');
        this.emailValue = this.email.value;

        // Get the phone value from the form input
        this.phone = this.querySelector('.como-form__input__phone');
        this.phoneValue = this.phone.value;

        // Get the email opt-in value from the form input
        this.emailOptIn = this.querySelector('.como-form__opt-in__email').checked;

        // Get the phone opt-in value from the form input
        this.phoneOptIn = this.querySelector('.como-form__opt-in__sms').checked;

        // Call the API function with the email value
        if (this.email.checkValidity() && this.phone.checkValidity() ){
          if(this.fName && this.lName && this.emailValue && this.phoneValue && this.emailOptIn && this.phoneOptIn ) {
            this.registerCustomerEmail(this.fName, this.lName, this.emailValue, this.phoneValue, this.tag);
          } else {
            dataLayer.push({'event': 'Como verification error: Not all fields included'});
            this.messageContainer.dataset.status = 'error';
            this.messageContainer.innerHTML = "Looks like something is missing. Please fill out all information.";
            this.button.disabled = false;
          }
        } else {
          dataLayer.push({'event': 'Como verification error: Email and phone do not match required format'});
          this.messageContainer.dataset.status = 'error';
          this.messageContainer.innerHTML = "Please check that your email and phone number are correct and try again.";
          this.button.disabled = false;
        }
    }

    // Call to the lambda function with the name, last name and email values
    registerCustomerEmail(firstName, lastName, email, phone) {
      
      const apiUrl = 'https://register-or-update-como.alisha-garric.workers.dev';

      const requestData = {
        email: email,
        phone: phone,
        firstName: firstName,
        lastName: lastName,
        location: this.location,
        tag: this.tag
      };

      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      let url = `${apiUrl}?email=${requestData.email}&phoneNumber=${requestData.phone}&firstName=${requestData.firstName}&lastName=${requestData.lastName}&genericString1=${requestData.location ? requestData.location : "Online"}`;
      
      if (requestData.tag) {
        url = `${url}&genericString3=${requestData.tag}`;
      } 

      url = `${url}&allowEmail=True&allowSMS=True&consent=yes`;


      // Main fetch method to the lambda function
      fetch(url, requestOptions)
        .then(response => response.json())
        .then(data => {
          data = data.userData;
          console.log(data);
          if (data.status === 'ok') {
            dataLayer.push({'event': 'Como submission success: New registration or complete member profile'});
            this.messageContainer.dataset.status = 'success';
            data.buffMessageWithOffer = this.dataset.successMessageOverride ? this.dataset.successMessageOverride : data.buffMessageWithOffer;
            data.buffMessage = this.dataset.successMessageOverride ? this.dataset.successMessageOverride : data.buffMessage;
          } else if (data.feedback?.updateUsingEmail === 'ok' || data.feedback?.updateUsingPhone === 'ok'){
            dataLayer.push({'event': 'Como submission success: New registration or complete member profile'});
            this.messageContainer.dataset.status = 'success';
          } else if (data.status === 'error') {
            dataLayer.push({'event': 'Como submission error: Existing phone number and email'});
            this.messageContainer.dataset.status = 'error';
          }
          this.messageContainer.innerHTML = this.displayOffer ? data.buffMessageWithOffer : data.buffMessage;
          this.button.disabled = false;
        })
        .catch(error => {
          dataLayer.push({'event': `Como submission error: ${error}`});
          this.messageContainer.dataset.status = 'error';
          this.messageContainer.innerHTML = error;
          this.button.disabled = false;
        });
    }
  }

  customElements.define('store-page-sign-up', StorePageSingUpSection);
}